export default {
  ADDITIONAL_HOURS: 'ADDITIONAL_HOURS',
  EXTRA_CHARGE: 'EXTRA_CHARGE',
  EXTRA_DISCOUNT: 'EXTRA_DISCOUNT',
  LABOR: 'LABOR',
  SUPPLIES: 'SUPPLIES',
  UNKNOWN: 'UNKNOWN',
  VALUATION_COVERAGE: 'VALUATION_COVERAGE',
};
